module.exports = __webpack_public_path__ + "img/irq.711f016f.svg";